import React from "react";
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './BrandManageGroup.css';
import EditComponent from "../EditComponent";



class BrandManageGroup extends React.Component {
  state = {
    isEdit: false,
  }

  toggleEdit = () => {
    const { isEdit } = this.state;
    this.setState({
      isEdit: !isEdit,
    })
  }
  render(){
    const { title, list, onChange, onSave, style, isEdit } = this.props;
    // const { isEdit } = this.state;
    return (
      <div className={s.root} style={style}>
        <div style={{ display: 'flex', justifyContent: 'space-between'}}>
          <div className={s.title}>{title || '通用'}</div>
          {/* <div><Button onClick={this.toggleEdit}>编辑</Button></div> */}
        </div>
        <EditComponent
          isEdit={isEdit}
          wordList={list || []}
          onChange={onChange}
          onSave={onSave}
        />
      </div>
    )
  }
}

export default withStyles(s)(BrandManageGroup);


// WEBPACK FOOTER //
// src/routes/cms/components/BrandComponent/BrandManageGroup.js